<template>
    <auto-modal
        v-if="shouldShowIntroModal && isIntroModalEnabled"
        modal-size="medium"
        @close="closeIntroModal"
    >
        <template v-slot:content>
            <div class="flex flex-col items-center justify-center text-[14px]">
                <h1 class="text-[24px] font-semibold mb-[4px]">
                    {{ $t('CUSTOMIZING_YOUR_PUTTER') }}
                </h1>
                <p class="text-center max-w-[380px] leading-6">
                    <span>{{ $t('INTRO_MODAL_TEXT_1A') }}&nbsp;</span>
                    <span class="font-semibold">{{ $t('INTRO_MODAL_TEXT_1B') }}&nbsp;</span>
                    <span>{{ $t('INTRO_MODAL_TEXT_1C') }}&nbsp;</span>
                    <span>{{ $t('INTRO_MODAL_TEXT_1D') }}</span>
                </p>
                <hr class="w-[200px] my-[10px]">
                <p class="text-center max-w-[380px] leading-6 cz3__info-modal__link-text-red">
                    {{ $t('INTRO_MODAL_TEXT_2A') }}
                    <a
                        href="https://www.vokey.com"
                        target="_blank"
                    >
                        {{ $t('INTRO_MODAL_TEXT_2B') }}
                    </a>
                </p>
            </div>
        </template>
    </auto-modal>
</template>

<script>
    import allStores from '../stores/all';
    import AutoModal from './AutoModal.vue';

    export default {
        mixins: [allStores],

        components: {
            AutoModal,
        },

        data() {
            return {
                shouldShowIntroModal: false,
            };
        },

        mounted() {
            if (!sessionStorage.getItem('introModalShown')) {
                this.shouldShowIntroModal = true;
                sessionStorage.setItem('introModalShown', 'true');
            }
        },

        methods: {
            closeIntroModal() {
                this.shouldShowIntroModal = false;
            },
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            isIntroModalEnabled() {
                return this.viewController?.blueprint?.custom?.['titleist-intro-modal'] === 'true';
            },
        },
    };
</script>
